import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";

const CustomButton = (props:any) => {
  const useStyle = makeStyles((theme) => ({
    root:{},
    btnDefault: {
      borderRadius: 15,
      fontSize: 12,
      lineHeight: 1.5,
      padding: `${theme.spacing(0.75)}px ${theme.spacing(2)}px`,
      textTransform: "capitalize",
    },
    btndefaultrounded: {
      borderRadius: 18,
    },
    btnLink: {
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
      fontWeight: 500,
      padding: 0,
      fontSize: 16,
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  }));
  const classes = useStyle();
  const btnClasses = classNames(
    classes.root,
    props.className ? props.className : null,
    props.variant && props.variant === "link" ? classes.btnLink : null,
    props.default
      ? classes.btnDefault
      : props.defaultrounded
      ? classes.btndefaultrounded
      : null
  );
  return (
    <Button {...props} className={btnClasses}>
      {props.children}
      {props.btnType}
    </Button>
  );
};

export default CustomButton;
